import React, { useEffect, useState } from 'react';
import connect from "react-redux/es/components/connect";
import { useNavigate } from "react-router-dom";
import Box from '@mui/system/Box';
import {
    FormControl, AccordionSummary, Accordion, AccordionDetails, Typography,
    Select, MenuItem, TextField, Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { actionGetSupervisorList } from "../store/action/RemoteActionSupervisor";
import translate from "../i18n/translate";
import { resetTimout } from "./common/FirebaseSupervisor";

let BASE_URL = process.env.REACT_APP_SERVER_URL_API;

const SupervisorList = (props) => {
    const navigate = useNavigate();
    const [message, setMessage] = useState("");
    const [language, setLanguage] = useState("");
    const [isError, setIsError] = useState(false);
    const [searchField, setSearchField] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState('');

    const Message = ({ message }) => (
        <section>
            <p style={{ color: isError ? "red" : "blue" }}>{message}</p>
        </section>
    );

    const onClickSearch = () => {
        resetTimout();
        const requestBody = {
            SearchField: searchField,
            SearchKeyword: searchKeyword
        };
        props.actionGetSupervisorList(requestBody);
    };

    const handleChange = (e) => {
        resetTimout();
        let eventValue = e.target.value;
        switch (e.target.name) {
            case "search-field":
                eventValue = parseInt(eventValue);
                setSearchField(eventValue);
                if (eventValue === 0) {
                    setSearchKeyword("");
                }
                break;
            case "search-keyword":
                setSearchKeyword(eventValue);
                break;
            default:
                console.log(e.target.name);
        }
    };

    const goToAddSupervisor = (e) => {
        resetTimout();
        window.location.href = '/addsupervisor';
    };

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        const requestBody = {
            SearchField: 0,
            SearchKeyword: ''
        };
        props.actionGetSupervisorList(requestBody);
    }, []);

    return (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-SupervisorList')}</h2>
            {/* if there is no transaction you can use this code */}
            {message ? (
                <Message message={message} />
            ) : ''}

            <Box sx={{ display: 'flex' }}>
                <Accordion sx={{ display: 'nowrap', marginBottom: '10' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography>{translate('Filters')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <Select id="search-field" name="search-field" value={searchField} label={translate('SearchField')} onChange={handleChange}>
                                <MenuItem value={0}><em>{translate('Select-SearchField')}</em></MenuItem>
                                <MenuItem value={1}>{translate('AdminID')}</MenuItem>
                                <MenuItem value={2}>{translate('MailID')}</MenuItem>
                                <MenuItem value={3}>{translate('AdminName')}</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <TextField id="search-keyword" name="search-keyword" value={searchKeyword} label={translate('SearchKeyword')} variant="outlined" size="small" onChange={handleChange} />
                        </FormControl>

                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                            <Button variant="contained" onClick={() => onClickSearch()}>{translate('btnSearch')}</Button>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
            </Box>

            <div className="gaps-3x" />
            <table className="adminTable" style={{ width: 820 }}>
                <tbody>
                    <tr className="adminTR">
                        <th className="adminTH" style={{ width: '27%' }} >{translate('AdminID')}</th>
                        <th className="adminTH" style={{ width: '27%' }} >{translate('MailID')}</th>
                        <th className="adminTH" style={{ width: '20%' }}>{translate('AdminName')}</th>
                        <th className="adminTH" style={{ width: '10%' }}>{translate('Status')}</th>
                        <th className="adminTH" style={{ width: '16%' }}>{translate('CreatedDate')}</th>
                    </tr>
                    {props?.supervisorList?.map((txn, index) => {
                        return <tr className="adminTR" key={txn.AUTORECID}>
                            <td className="adminTD" width='27%' align='left'>{txn.AdminID}</td>
                            <td className="adminTD" width='27%' align='left'>{txn.MailID}</td>
                            <td className="adminTD" width='20%' align='left'>{txn.FirstName + ' ' + txn.LastName}</td>
                            <td className="adminTD" width='10%' align='left'>{txn.AdminStatus}</td>
                            <td className="adminTD" width='16%' align='left'>{txn.DateCreated}</td>
                        </tr>
                    })
                    }
                </tbody>
            </table>

            <div className="gaps-2x" />
            <div>
                <button className="btn btn-primary" onClick={event => goToAddSupervisor(event)}>{translate('btnAddNew')}</button>
            </div>

        </div>

    );
};

const mapStateToProps = state => {
    return {
        supervisorList: state.remote.supervisorList
    };
};

export default connect(mapStateToProps, {
    actionGetSupervisorList
})(SupervisorList);
